export const stakeHolderIntExt = [
  {value: 'internalStakeholder', label: 'Internal Stakeholder'},
  {value: 'externalStakeholder', label: 'External Stakeholder'}
];
export const stakeholdersTypeKeyLabel = [
  {value: 'facility', label: 'Facility', stakeholder: 'internalStakeholder'},
  {value: 'supplier', label: 'Suppliers', stakeholder: 'externalStakeholder'},
  {value: 'franchise', label: 'Franchise', stakeholder: 'externalStakeholder'},
  {value: 'holding', label: 'Holding', stakeholder: 'externalStakeholder'},
  {
    value: 'downstreamLeasedAsset',
    label: 'Tenants',
    stakeholder: 'externalStakeholder'
  }
];
